// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__qZIz4","content":"styles_content__32LxJ","row":"styles_row__1HBjg","footer":"styles_footer__j3Af_","phraseLength":"styles_phraseLength__6GN7_"};